import React, { Component } from 'react';
import { Form, Button, Divider, TextArea, Dropdown } from 'semantic-ui-react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';

import { getAd } from '../../fbApi/Ad';
import getPages from '../../fbApi/User';
import { publishPost, schedulePost } from '../../fbApi/Post';
import { fillHours } from '../../utils/dates';
import './OrganicApi.css';

class OrganicApi extends Component {
  state = {
    form: {
      adId: '',
      schedule: false,
    },
    log: '',
    pageId: '',
    date: null,
    convertedDate: '',
    selectedHour: null,
    selectedHourName: '',
    hours: []
  }

  componentDidMount() {
    this.props.setSectionTitle('Organic API');
    this.props.saveGTMEvent('Organic API', 'Organic API');
    this.fillHours();
  }

  onHourSelect = (event, data) => {
    const hour = data.options.find(item => item.value === data.value);
    this.setState({ selectedHour: data.value, selectedHourName: hour.text });
  }

  publishPost = async (postId, pageToken) => {
    const data = {
      id: postId,
    };

    const result = await publishPost(data, pageToken);

    if (result.error) {
      this.setState({ log: result.error.message });
    } else {
      this.setState({ log: 'The post has been published' });
    }
  }

  schedulePost = async (postId, pageToken) => {
    const timestamp = Math.round(this.state.convertedDate.getTime() / 1000);

    const data = {
      id: postId,
      timestamp
    };

    const result = await schedulePost(data, pageToken);

    if (result.error) {
      this.setState({ log: result.error.message });
    } else {
      this.setState({ log: `The post has been scheduled to be published at ${this.state.convertedDate.toISOString().split('T')[0]} ${this.state.selectedHourName}` });
    }
  }

  fillHours = () => {
    this.setState({ hours: fillHours() });
  }

  handleFormChange = (event, { name, value }) => {
    this.setState({ form: { ...this.state.form, [name]: value } });
  };

  handleFormCheckBox = (event, { name, checked }) => {
    this.setState({ form: { ...this.state.form, [name]: checked } });
  };

  validDate = () => {
    if (!this.state.selectedHour || !this.state.date) {
      return false;
    }

    let hour = this.state.selectedHour.replace('am', '');
    hour = hour.replace('pm', '');
    const hourParts = hour.split(':');
    const date = this.state.date;

    date.setHours(hourParts[0]);
    date.setMinutes(hourParts[1]);
    const startDate = new Date();
    const endDate = new Date();
    startDate.setMinutes(startDate.getMinutes() + 10);
    endDate.setMonth(endDate.getMonth() + 6);
    this.setState({ convertedDate: date });

    return (date >= startDate && date <= endDate);
  }

  publish = async () => {
    this.setState({ log: '' });

    const adId = this.state.form.adId;
    const schedule = this.state.form.schedule;

    if (schedule && !this.validDate()) {
      this.setState({ log: 'The schedule date must be between 10 minutes and 6 months from the current date' });
      return;
    }

    const token = this.props.getFbToken();
    const ad = await getAd(adId, token);

    if (ad.error) {
      this.setState({ log: 'Error requesting the ad' });
      return;
    }

    const postId = ad.creative.effective_object_story_id;
    const pageId = postId.split('_')[0];

    const pages = await getPages(token);

    if (pages.error) {
      this.setState({ log: 'Error requesting the pages' });
      return;
    }

    const page = pages.data.find(item => item.id === pageId);

    if (!page) {
      this.setState({ log: 'The page does not belong to the user' });
      return;
    }

    this.setState({ pageId: page.name });

    if (schedule) {
      await this.schedulePost(postId, page.access_token);
    } else {
      await this.publishPost(postId, page.access_token);
    }
  }

  selectDate = (day) => {
    this.setState({ date: day });
  }

  render() {
    const { adId } = this.state.form;
    return (
      <div>
        <Form.Input
          placeholder="Ad Id"
          type="text"
          name="adId"
          value={adId}
          onChange={this.handleFormChange}
        />
        <Divider hidden />
        <Form.Input
          placeholder="Page Id"
          type="text"
          name="pageId"
          disabled
          className="page-field"
          value={this.state.pageId}
          onChange={this.handleFormChange}
        />
        <Divider hidden />
        <div className="schedule-container">
          <Form.Checkbox
            label="Schedule"
            name="schedule"
            onChange={this.handleFormCheckBox}
          />
          { this.state.form.schedule ?
            <div className="date-selector">
              <DayPickerInput
                onDayChange={day => this.selectDate(day)}
              />
              <Dropdown
                placeholder="Time"
                search
                selection
                className="time-selector"
                options={this.state.hours}
                onChange={this.onHourSelect}
              />
            </div>
            : null
          }
        </div>
        <Divider hidden />
        <Button
          onClick={this.publish}
          size="small"
          color="blue"
        >
          Publish
        </Button>
        <Divider hidden />
        <TextArea
          className="debug-log"
          placeholder="Debug Log"
          disabled
          rows="10"
          cols="100"
          value={this.state.log}
        />
      </div>
    );
  }
}

export default OrganicApi;



// WEBPACK FOOTER //
// ./src/screens/Organic/OrganicApi.js